<template>
  <v-container>
    <helmet-provider>
      <div>
        <helmet>
          <title>NEO Scavenger 日本語化 - 日本語化ファイル置き場 -</title>
          <meta name='description' content='Steamで配信中のサバイバルロールプレイングゲーム、"NEO Scavenger" の日本語化に関するページです。'>
          <meta property='og:title' content='日本語化ファイル置き場'/>
          <meta property='og:description' content='Steamで配信中のサバイバルロールプレイングゲーム、"NEO Scavenger" の日本語化に関するページです。'/>
          <meta property='og:image' content='https://storage.googleapis.com/porte-parapluies.appspot.com/Neoscavenger/001s.webp'/>
          <meta property='og:url' content='https://porte-parapluies.web.app/games/neoscavenger/'/>
          <meta property='og:type' content='website'/>
        </helmet>
      </div>
    </helmet-provider>
    <page-title 
      title='NEO Scavenger 日本語化'
      link='https://porte-parapluies.web.app/games/neoscavenger/'/>
    <game-info 
      gameName='NEO Scavenger' 
      gameLink='https://store.steampowered.com/app/248860/NEO_Scavenger/' 
      makerName='Blue Bottle Games' 
      makerLink='https://bluebottlegames.com'/>
    <page-contents 
      title="ゲームの内容"
      :contents=contents />
    <page-contents
      title="導入方法"
      :contents=guides />
    <game-image 
      title="日本語化Mod適用後のイメージ"
      path="Neoscavenger"
      :images=images />
  </v-container>
</template>

<script>
import { HelmetProvider, Helmet } from "@jnields/vue-helmet";

import PageTitle from '@/components/PageTitle.vue'
import GameInfo from '@/components/GameInfo.vue'
import PageContents from '@/components/PageContents.vue'
import GameImage from '@/components/GameImage.vue'

export default {
  components: {
    PageTitle,
    GameInfo,
    PageContents,
    GameImage,
    HelmetProvider, 
    Helmet
  },
  data(){
    return{
      contents:[
        'NEO Scavengerはポストアポカリプスの世界を生き抜き、冒険するサバイバルロールプレイングゲームです。'
      ],
      guides:[
        '日本語フォント追加バッチと日本語化ModはGoogleドライブに置いてあります。<a href="https://drive.google.com/drive/folders/1-qzgKR5kS7nrmkXerRU7FXZNKfCMSALr?usp=sharing" target="_blank">こちら</a>からダウンロードして中のreadme.txtの手順に従って導入してください。',
      ],
      images:[
        {
          alt:'エンカウンター画面',
          overlay: false
        },
        {
          alt:'クラフト画面',
          overlay: false
        }
      ],
    }
  }
};
</script>
